// Data is fetched from the backend every five minutes.
export const POLLING_INTERVAL = 1000 * 300

export const NOTIFICATIONS_POLLING_INTERVAL = 1000 * 60 * 5

export const DEFAULT_PAGINATION_PAGE = 1

// Seconds a notification will be shown in the top-right corner.
export const NOTIFICATIONS_DURATION = 8
